import React from "react";
import "./Faq.scss";
import FAQAI from "./FAQAI";
const Faq = () => <div className="faq_section"><div className="container-fluid"><FAQAI /></div></div>;
export default Faq;
